import { getUserTokenFromStorage } from "../../_config/helper.config";
import { PostService } from "../../_service";

export const GET_POST_DETAIL_ACTION = "GET_POST_DETAIL_ACTION";
export const GET_POST_DETAIL_SUCCESS = "GET_POST_DETAIL_SUCCESS";
export const GET_POST_DETAIL_ERROR = "GET_POST_DETAIL_ERROR";
export const UPDATE_POST_DETAIL = "UPDATE_POST_DETAIL";

export function getPostDetailAction() {
  return {
    type: GET_POST_DETAIL_ACTION,
  };
}

export const getPostDetailSuccess = (post, commentsMeta) => ({
  type: GET_POST_DETAIL_SUCCESS,
  post,
  commentsMeta,
});

export const getPostDetailError = (errorMessage, statusCode) => {
  return {
    type: GET_POST_DETAIL_ERROR,
    error: errorMessage,
    statusCode: statusCode,
  };
};

export const updatePostDetail = (post) => ({
  type: UPDATE_POST_DETAIL,
  post,
});

export function getPostDetailById(postId) {
  return async (dispatch) => {
    dispatch(getPostDetailAction());
    const token = getUserTokenFromStorage();
    try {
      const { post, commentsPage, commentsLimit, commentsHasMore } =
        await PostService.getPostDetail({ token }, postId, {
          commentPage: 1,
          commentLimit: 20,
        });
      dispatch(
        getPostDetailSuccess(post, {
          page: commentsPage,
          limit: commentsLimit,
          hasMore: commentsHasMore,
        })
      );
    } catch (error) {
      dispatch(
        getPostDetailError("Post could not be fetched!", error.response.status)
      );
    }
  };
}

export function getPostDetailBySlug(slug) {
  return async (dispatch, getState) => {
    const { community } = getState();
    dispatch(getPostDetailAction());
    const token = getUserTokenFromStorage();
    try {
      const { post, commentsPage, commentsLimit, commentsHasMore } =
        await PostService.getPostDetailFromSlug(
        { token },
        community.id,
        slug,
        {
          commentPage: 1,
          commentLimit: 20,
        }
      );
      dispatch(
        getPostDetailSuccess(post, {
          page: commentsPage,
          limit: commentsLimit,
          hasMore: commentsHasMore,
        })
      );
    } catch (error) {
      dispatch(
        getPostDetailError("Post could not be fetched!", error.response.status)
      );
    }
  };
}

const INITIAL_STATE = {
  post: null,
  isLoading: false,
  error: null,
  commentsMeta: {
    page: 1,
    limit: 20,
    hasMore: false,
  },
};

export function postDetailReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_POST_DETAIL_ACTION:
      return {
        ...state,
        isLoading: true,
        post: null,
        error: null,
      };
    case GET_POST_DETAIL_SUCCESS:
      const nextCommentsMeta = action.commentsMeta ?? state.commentsMeta;
      return {
        ...state,
        isLoading: false,
        post: action.post
          ? {
              ...action.post,
              commentsMeta: nextCommentsMeta,
            }
          : action.post,
        error: null,
        commentsMeta: nextCommentsMeta,
      };
    case GET_POST_DETAIL_ERROR:
      return {
        ...state,
        isLoading: false,
        post: null,
        error: action.error,
        statusCode: action.statusCode,
      };
    case UPDATE_POST_DETAIL:
      return {
        ...state,
        isLoading: false,
        post: action.post
          ? {
              ...action.post,
              commentsMeta: action.post.commentsMeta ?? state.commentsMeta,
            }
          : action.post,
        error: null,
      };
    default:
      return state;
  }
}
